<template>
  <div>
    <common-dialog
      ref="dialog"
      width="660px"
      unit="分组管理"
      edit-title
      id-key="GroupId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="学校" prop="SchoolId">
              <el-select size="mini" v-model="data.SchoolId" style="width:100%;">
                <el-option
                  v-for="(i,key) in schools"
                  :key="key"
                  :label="i.SchoolName"
                  :value="i.SchoolId"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="分组名称" prop="GroupName">
              <el-input v-model="data.GroupName" placeholder="请填写分组名称"></el-input>
              <!-- {{data.BaseCharge}} -->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input type="textarea" v-model="data.Remark" :rows="4" placeholder="请填写备注"></el-input>
              <!-- {{data.BaseCharge}} -->
            </el-form-item>
          </el-col>
          <!-- <el-col :span="isMB?24:12">
            <el-form-item label="状态" prop="Status">
              <el-radio-group v-model="data.Status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          
          <el-col :span="24">
            <el-form-item label="" prop="FeeRules" label-width="0">
              <div style="margin:-10px 0 5px;">备注</div>
              <el-input type="textarea" v-model="data.Remark" :rows="8" placeholder="请填写备注"></el-input>
            </el-form-item>
          </el-col> 
          -->
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        GroupId: 0,
        SchoolId: null,
        GroupName: "",
        VaCharge: null,
        StartMonth: "",
        StartMonthDate: "",
        EndMonth: "",
        EndMonthDate: "",
        RechargeMonth: "",
        RechargeMonthDate: "",
        FreeMonth: 0,
        GiveCharge: 0,
        TotalMonth: 0,
        TotalCharge: 0,
        TotalBaseCharge: 0,
        FeeRules: "",
        PushFace: true,
        PushPhone: true,
        NoMonths: "",
        Remark:'',
        Status: 1,
      },
      schools: [],
      nm: [],
      api: require("@/api/st/group").default,
      school_api: require("@/api/st/school").default,
      isMB: this.$store.state.isMB,
      rules: {
        SchoolId: [{ required: true, message: "请选择学校" }],
        GroupName: [{ required: true, message: "请填写分组名称" }],
        VaCharge: [{ required: true, message: "请填写增值费用" }],
        StartMonth: [{ required: true, message: "请选择开始月份" }],
        EndMonth: [{ required: true, message: "请选择结束月份" }],
        RechargeMonth: [{ required: true, message: "请选择开始开通月份" }],
        Status: [{ required: true, message: "请选择状态" }],
      },
    };
  },
  computed: {
    monthList() {
      if(this.data.StartMonth && this.data.EndMonth) {
        var arr = this.getMonths(this.data.StartMonth,this.data.EndMonth);
        if(this.data.FreeMonth == 0) return arr;
        else if(this.data.FreeMonth >= arr.length) return [];
        else return arr.slice(this.data.FreeMonth);
      }
      return [];
    },
  },
  methods: {
    onCreateOpened() {
      this.school_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.schools = res.Data;
      });
    },
    onEditOpened(data) {
      if(data.NoMonths) {
        this.nm = data.NoMonths.split(",");
      }
      this.school_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.schools = res.Data;
      });
    },
    setDate(date) {
      if (date) {
        this.data.RentMon = date;
      } else {
        this.data.RentMon = "";
      }
    },
    checkDate() {
      this.nm = [];
      if(!this.data.StartMonth || !this.data.EndMonth) return;
      var s = this.data.StartMonth + "-01";
      var e = this.data.EndMonth + "-01";
      var st = new Date(s).getTime();
      var et = new Date(e).getTime();
      if(st > et) {
        this.$message.error("开始月份不能超过结束月份");
        this.data.EndMonth = "";
      } 
      this.countNum();
    },
    countNum(resetNM) {
      if(!(resetNM === false)) this.nm = [];
      if(!(this.data.BaseCharge >= 0)) this.data.BaseCharge = null;
      if(!(this.data.VaCharge >= 0)) this.data.VaCharge = null;
      if(!(this.data.FreeMonth >= 0)) this.data.FreeMonth = null;

      if(!this.data.StartMonth ||!this.data.EndMonth) return;
      var e = new Date(this.data.EndMonth + "-01").getTime() + 31*86400*1000;
      var ed = this.$commonJs.toDateString(e).split("-");
      var ne = new Date(ed[0]+"-"+ed[1]+"-01").getTime();
      this.data.EndMonthDate = this.$commonJs.toDateString(ne - 86400000);
      this.data.StartMonthDate = this.data.StartMonth + "-01";
      this.data.TotalMonth = this.datemonth(this.data.StartMonthDate,this.data.EndMonthDate);
      if(this.data.FreeMonth >= this.data.TotalMonth) {
        this.data.TotalCharge = 0;
        this.data.TotalBaseCharge = 0;
      } else {
        this.data.TotalCharge = (this.data.TotalMonth - this.data.FreeMonth) * 100 * (Number(this.data.BaseCharge) + Number(this.data.VaCharge)) / 100;
        this.data.TotalBaseCharge = (this.data.TotalMonth - this.data.FreeMonth) * 100 * Number(this.data.BaseCharge) / 100;
      }
      if(this.nm.length) {
        this.data.TotalCharge = this.data.TotalCharge - (Number(this.data.BaseCharge) + Number(this.data.VaCharge)) * this.nm.length;
        this.data.TotalBaseCharge = this.data.TotalBaseCharge - Number(this.data.BaseCharge) * this.nm.length;
      }
    },
    checkNum() {
      if(!(this.data.GiveCharge > 0)) this.data.GiveCharge = 0;
    },
    onBeforeSave() {
      // if(this.data.FreeMonth > this.data.TotalMonth) {
      //   this.$message.error("赠送月份不能超过周期月份");
      //   return false;
      // }
      // var s = this.data.StartMonth + "-01";
      // var r = this.data.RechargeMonth + "-01";
      // var st = new Date(s).getTime();
      // var rt = new Date(r).getTime();
      // if(rt > st) {
      //   this.$message.error("开始月份不能在开始开通月份之前");
      //   return false;
      // }
      // var sub = this.datemonth2(this.data.StartMonth,this.data.RechargeMonth);
      // if(sub > 2) {
      //   this.$message.error("开始开通月份不能比开始月份提前2个月以上");
      //   return false;
      // }
      // this.data.RechargeMonthDate = this.data.RechargeMonth + "-01";
      // if(!(this.data.FreeMonth > 0)) this.data.FreeMonth = 0;
      // this.data.NoMonths = this.nm.join(",");
      this.loading(true);
      // this.api.getLastPackage({ schoolId: this.data.SchoolId, startMonthDate: this.data.StartMonth + "-01" }).then(res => {
      //   if(res.Code==0) {
      //     if(res.Data && res.Data.PackageId != this.data.PackageId) {
      //       var sub2 = this.datemonth2(this.data.RechargeMonth,res.Data.EndMonth);
      //       if(sub2 < -1) {
      //         this.loading(false);
      //         this.$message.error("开始开通月份最多比上一个周期的结束月份提前1个月")
      //         return false;
      //       }
      //       this.toSave();
      //     } else {
      //       this.toSave();
      //     }
      //   } else {
      //     this.loading(false);
      //   }
      // })
      this.toSave();
      return false;
    },
    toSave() {
      this.api.save(this.data).then(res2 => {
        this.loading(false);
        if(res2.Code==0) {
          this.$message.success(res2.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res2.Msg);
        }
      })
    },
    datemonth(date1,date2) {
      // 拆分年月日
      date1 = date1.split('-');
      // 得到月数
      date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
      // 拆分年月日
      date2 = date2.split('-');
      // 得到月数
      date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
      var m = Math.abs(date1 - date2); //Math.abs()取绝对值
      return m + 1;
    },
    datemonth2(date1,date2) {
      // 拆分年月日
      date1 = date1.split('-');
      // 得到月数
      date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
      // 拆分年月日
      date2 = date2.split('-');
      // 得到月数
      date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
      var m = date1 - date2; //Math.abs()取绝对值
      return m;
    },
    getMonths(date_one,date_tow){
      let one = date_one.split('-')
      let tow = date_tow.split('-')
      
      const y2 = parseInt(tow[0])
      let y1 = parseInt(one[0])
      const m2 = parseInt(tow[1])
      let m1 = parseInt(one[1])

      let count = ( y2 - y1 ) * 12 +  m2 - m1
      var result = [];
      for (let i = 0 ;count >= 0;) {
        if (m1 <= 12){
          m1 = m1<10?('0'+m1):m1
          let temp = y1 + '-' + m1
          result.push(temp)
          ++m1
          count --
          ++i
        } else {
          m1 -= 12
          y1++
        }
      }
      return result;
    },
    onClosed() {
      this.schools = [];
      this.nm = [];
    },
  }
};
</script>
<style lang="scss">
.longLabel {
  .el-form-item__label {
    width: 140px !important;
  }
  .el-form-item__content {
    margin-left: 140px !important;
  }
}
.longLabel2 {
  .el-form-item__label {
    width: 110px !important;
  }
  .el-form-item__content {
    margin-left: 110px !important;
  }
}
.longLabel3 {
  .el-form-item__label {
    width: 85px !important;
  }
  .el-form-item__content {
    margin-left: 85px !important;
  }
}
</style>